// src/services/ProductTypeService.ts
import axios from "axios";

const API_BASE = process.env.REACT_APP_BASE_URL; 

export interface ProductType {
  id: string;
  name: string;
  description?: string;
  products?: any[]; 
}

export interface ProductTypeFormData {
  name: string;
  description?: string;
}

export const ProductTypeService = {
  /** Fetch all product types */
  getAll: async (): Promise<ProductType[]> => {
    const res = await axios.get(`${API_BASE}/product-types`, { withCredentials: true });
    return res.data;
  },

  /** Fetch a single product type by ID */
  getById: async (id: number): Promise<ProductType> => {
    const res = await axios.get(`${API_BASE}/product-types/${id}`, { withCredentials: true });
    return res.data;
  },

  /** Create a new product type */
  create: async (data: ProductTypeFormData): Promise<ProductType> => {
    const res = await axios.post(`${API_BASE}/product-types`, data, { withCredentials: true });
    return res.data;
  },

  /** Update an existing product type */
  update: async (id: number, data: Partial<ProductTypeFormData>): Promise<ProductType> => {
    const res = await axios.put(`${API_BASE}/product-types/${id}`, data, { withCredentials: true });
    return res.data;
  },

  /** Delete a product type */
  delete: async (id: number): Promise<void> => {
    await axios.delete(`${API_BASE}/product-types/${id}`, { withCredentials: true });
  },
};
